import React from "react";
import Activities from "../components/Activities";
import { FaMapLocationDot } from "react-icons/fa6";
// import { Carousel } from "react-bootstrap";
import { Carousel, initMDB } from "mdb-ui-kit";
import CarouselShow from "../components/CarouselShow";
import TestimonialSection from "../components/Testimonials";

import AOS from "aos";
import "aos/dist/aos.css";

AOS.init({
  duration: 1200,
  easing: "ease-in-out",
});

initMDB({ Carousel });

const cardStyle = {
  width: "300px",
  // margin: "20px",
  borderRadius: "10px",
  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
  overflow: "hidden",
  backgroundColor: "#2c3447",
};

const imgStyle = {
  width: "100%",
  height: "auto",
  borderRadius: "10px 10px 0 0",
};

const cardBodyStyle = {
  padding: "20px",
  backgroundColor: "#f9f9f9",
};

const titleStyle = {
  marginBottom: "10px",
  fontSize: "1.5rem",
  color: "#333",
  fontFamily: "Arial, sans-serif",
};

const textStyle = {
  fontSize: "1rem",
  color: "#666",
  fontFamily: "Arial, sans-serif",
};

const Home = () => {
  return (
    <div className="">
      <style>
        {`
          .nss-logo {
            width: 150px;
            height: auto; 
            display: block;
            margin: 0 auto; 
          }

          @media (max-width: 576px) {
            .nss-logo {
              width: 150px;
              height: auto;
              margin: 0 auto; 
            }
          }
        `}
      </style>


      <CarouselShow />

      <div className="text-center mt-5">
        <img src="https://www.pict.edu/images/pic.jpg" />
        <h1 className="mt-4">PUNE INSTITUTE OF COMPUTER TECHNOLOGY
        </h1>
      </div>

      <h2 className="my-3 text-center mt-5 ">Vision & Mission</h2>


      {/* <div
          className="d-flex justify-content-center flex-column  px-5"
          data-aos="fade-top"
          data-aos-anchor-placement="top-center"
        >
          <h2 className="my-3 px-5 text-center mt-5 typewriter-text2">Vision</h2>
          <h5 className="my-3 px-5 text-center ">
          Pune Institute of Computer Technology aspires to be the leader in Higher technical education and research of International repute.
          <br />
          </h5>
          <h2 className="my-3 px-5 text-center typewriter-text2">Mission</h2>
          <h5 className="my-3 px-5 text-center ">
          To be the leading and the most sought after institute of education and research in emerging engineering and technology disciplines that attract, retains and sustains gifted individuals of significant potential.
          </h5>
          <h2 className="my-3 px-5 text-center typewriter-text2">About PICT</h2>
          <h5 className="my-3 px-5 text-center " style={{ textAlign: 'justify' }}>
           Pune Institute of Computer Technology (popularly known as PICT), is an elite academic Institute located in Pune, “The Oxford of the East.” Since our establishment in 1983, PICT has been revolutionizing the education sector by nurturing skilled and industry-ready engineers.
           PICT is a UGC Approved Institute, ISO 9001:2015 Certified, and is NAAC Accredited (4th Cycle) with A+ grade. All our UG programmes are NBA Accredited (CE and E&TE - 6 times, IT - 4 times). PICT is ranked 8th among private Engineering Institutions in India, 1st among all private Engineering Institutions in Maharashtra, and 4th among all Engineering Institutions, including IITs, NITs, and Govt. Colleges in Maharashtra (as per the EDU-RAND ranking- 2015). PICT is placed in the ranking band: 201 to 250 as per the NIRF 2021 Ranking.
          <br />
          </h5>
        </div> */}
      <div
        className="p-5 mt-5 text-white"
        style={{
          backgroundImage:
            "url(https://studiobackdrops.com/wp-content/uploads/2023/03/BE-WK-007-Purple-Path-Brushwork-Backdrops-1-400x500.jpg)",
          backgroundSize: "cover",
          backgroundPosition: "fixed",
          marginTop: '20px'
        }}
        data-aos="fade-top"
        data-aos-anchor-placement="top-center"
      >        <div
        className="d-flex justify-content-center flex-column p-3"
        data-aos="fade-top"
        data-aos-anchor-placement="top-center"

      >
          <h2 className="my-3 text-center mt-2 typewriter-text2">Vision</h2>
          <h5 className="my-3 text-center text-justify" style={{ textAlign: 'justify' }}>
            Pune Institute of Computer Technology aspires to be the leader in Higher technical education and research of International repute.
          </h5>


        </div>
        <div
          className="d-flex justify-content-center flex-column p-3"
          data-aos="fade-top"
          data-aos-anchor-placement="top-center"
        >
          <h2 className="my-3 text-center typewriter-text2">Mission</h2>
          <h5 className="my-3 text-center text-justify" style={{ textAlign: 'justify' }}>
            To be the leading and the most sought after institute of education and research in emerging engineering and technology disciplines that attract, retains and sustains gifted individuals of significant potential.
          </h5>


        </div>   </div>

      {/* style={{
    backgroundImage:
      "url(https://www.lichflfsl.com/assets/images/vision-mission.png )",
    backgroundSize: "cover",
    backgroundPosition: "fixed",
    marginTop:'20px'
  }} */}
      {/* https://e7.pngegg.com/pngimages/924/981/png-clipart-mission-statement-vision-statement-business-art-our-mission-text-service.png */}

      {/* what we do section */}


      <div className="text-center mt-5">
        <img
          src='https://i.postimg.cc/pTSWjNzG/Screenshot-694.png'
          alt="NSS Logo"
          className="nss-logo"
        />
        <h1 className="mt-4">National Service Scheme</h1>
      </div>
      {/* <div className="mt-5">
      <img 
        src='https://i.postimg.cc/pTSWjNzG/Screenshot-694.png' 
        alt="NSS Logo"
        className="d-none d-sm-block"
        style={{
          width: '10%',
          justifyContent: 'center',
          marginLeft: '45%',
        }}
      />
      <h1 className="mt-4 text-center">National Service Scheme</h1>
    </div> */}

      <h2 className="my-3 text-center mt-5 ">About PICT & PICT NSS</h2>
      <div
        className="p-5 mt-5 text-white"
        style={{
          backgroundImage:
            "url(https://cabinet-holistique.fr/images/main_lumiere.jpg)",
          backgroundSize: "cover",
          backgroundPosition: "fixed",
          marginTop: '20px'
        }}
        data-aos="fade-top"
        data-aos-anchor-placement="top-center"
      >
        <div
          className="d-flex justify-content-center flex-column align-items-center mb-3"
          data-aos="fade-bottom"
          data-aos-anchor-placement="top-center"
        >
          <h2 className="my-3">About Us</h2>
          <h5 className="my-3">
            Pune Institute of Computer Technology (popularly known as PICT), is an elite academic Institute located in Pune, “The Oxford of the East.” Since our establishment in 1983, PICT has been revolutionizing the education sector by nurturing skilled and industry-ready engineers. PICT is a UGC Approved Institute, ISO 9001:2015 Certified, and is NAAC Accredited (4th Cycle) with A+ grade. All our UG programmes are NBA Accredited (CE and E&TE - 6 times, IT - 4 times). PICT is ranked 8th among private Engineering Institutions in India, 1st among all private Engineering Institutions in Maharashtra, and 4th among all Engineering Institutions, including IITs, NITs, and Govt. Colleges in Maharashtra (as per the EDU-RAND ranking- 2015). PICT is placed in the ranking band: 201 to 250 as per the NIRF 2021 Ranking.
          </h5>
        </div>
        <div
          className="d-flex justify-content-center flex-column align-items-center mb-3"
          data-aos="fade-top"
          data-aos-anchor-placement="top-center"
        >
          <h2 className="my-3">Who are we?</h2>
          <h5 className="my-3">
            National Service Scheme,PICT Pune, being the largest student
            volunteer body, is the most active and perseverent organization in
            the campus  in the  field of the social /community service. We provide
            opportunities to students to contribute their bit in the welfare of
            the society. NSS has departments spanning all avenues of community
            service right from educating the underprivileged to innovating
            solutions to social problems using technology. <br />
            <br />
            Spreading happiness through community service has been one of the
            primary objectives of NSS. With innovative activities across the
            departments catering to all classes of the campus residents, we try
            to create small, happy and memorable moments in their lives. And
            working in NSS itself has been one of the prime sources of happiness
            for the people associated with us.
          </h5>
        </div>

        <div
          className="d-flex justify-content-center flex-column align-items-center "
          data-aos="fade-bottom"
          data-aos-anchor-placement="top-center"
        >
          <h2 className="my-3">What do we do?</h2>
          <h5 className="my-3">
            We aim to bring about positive change in society with a focus on education and development for the underprivileged, nature conservation, and promoting sustainability. Our team consists of over 150+ dedicated volunteers led by more than 20 head members, carrying out various initiatives throughout the year. We also collaborate closely with several NGOs and governmental bodies to reach as many beneficiaries as possible.
          </h5>
        </div>
      </div>

      {/* 
      testimonial section */}
      <div className="typewriter-text2 text-center mt-5">
        <h1 className="mt-5">Outreach</h1>
      </div>
      <section class="py-3 py-md-5">
        <div class="container">
          <div class="row justify-content-center">
            <div class="col-12 col-lg-10 col-xl-8 col-xxl-7">
              <div class="row gy-4">
                <div class="col-12 col-sm-6">
                  <div class="card widget-card border-light shadow-sm">
                    <div class="card-body p-4">
                      <div class="row" data-aos="fade-right">
                        <div class="col-8">
                          <h5 class="card-title widget-card-title mb-3">
                            Activities
                          </h5>
                          <h4 class="card-subtitle text-body-secondary m-0">
                            400+
                          </h4>
                        </div>
                        <div class="col-4">
                          <div class="d-flex justify-content-end">
                            <div class="lh-1 text-white bg-info rounded-circle p-3 d-flex align-items-center justify-content-center">
                              <i class="bi bi-truck fs-4"></i>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row" data-aos="fade-left">
                        <div class="col-12">
                          <div class="d-flex align-items-center mt-3">
                            <span class="lh-1 me-3 bg-danger-subtle text-danger rounded-circle p-1 d-flex align-items-center justify-content-center">
                              <i class="bi bi-arrow-right-short bsb-rotate-45"></i>
                            </span>
                            <div>

                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-12 col-sm-6">
                  <div class="card widget-card border-light shadow-sm">
                    <div class="card-body p-4">
                      <div class="row " data-aos="fade-right">
                        <div class="col-8">
                          <h5 class="card-title widget-card-title mb-3">
                            Collaborataions
                          </h5>
                          <h4 class="card-subtitle text-body-secondary m-0">
                            50+
                          </h4>
                        </div>
                        <div class="col-4">
                          <div class="d-flex justify-content-end">
                            <div class="lh-1 text-white bg-info rounded-circle p-3 d-flex align-items-center justify-content-center">
                              <i class="bi bi-currency-dollar fs-4"></i>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row" data-aos="fade-left">
                        <div class="col-12">
                          <div class="d-flex align-items-center mt-3">
                            <span class="lh-1 me-3 bg-success-subtle text-success rounded-circle p-1 d-flex align-items-center justify-content-center">
                              <i class="bi bi-arrow-right-short bsb-rotate-n45"></i>
                            </span>
                            <div>

                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-12 col-sm-6">
                  <div class="card widget-card border-light shadow-sm">
                    <div class="card-body p-4">
                      <div class="row" data-aos="fade-right">
                        <div class="col-8">
                          <h5 class="card-title widget-card-title mb-3">
                            Alumni Network
                          </h5>
                          <h4 class="card-subtitle text-body-secondary m-0">
                            650+
                          </h4>
                        </div>
                        <div class="col-4">
                          <div class="d-flex justify-content-end">
                            <div class="lh-1 text-white bg-info rounded-circle p-3 d-flex align-items-center justify-content-center">
                              <i class="bi bi-person fs-4"></i>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row" data-aos="fade-left">
                        <div class="col-12">
                          <div class="d-flex align-items-center mt-3">
                            <span class="lh-1 me-3 bg-success-subtle text-success rounded-circle p-1 d-flex align-items-center justify-content-center">
                              <i class="bi bi-arrow-right-short bsb-rotate-n45"></i>
                            </span>
                            <div>

                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-12 col-sm-6">
                  <div class="card widget-card border-light shadow-sm">
                    <div class="card-body p-4">
                      <div class="row" data-aos="fade-right">
                        <div class="col-8">
                          <h5 class="card-title widget-card-title mb-3">
                            Active Volunteers
                          </h5>
                          <h4 class="card-subtitle text-body-secondary m-0">
                            150+
                          </h4>
                        </div>
                        <div class="col-4">
                          <div class="d-flex justify-content-end">
                            <div class="lh-1 text-white bg-info rounded-circle p-3 d-flex align-items-center justify-content-center">
                              <i class="bi bi-cart fs-4"></i>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row" data-aos="fade-left">
                        <div class="col-12">
                          <div class="d-flex align-items-center mt-3">
                            <span class="lh-1 me-3 bg-danger-subtle text-danger rounded-circle p-1 d-flex align-items-center justify-content-center">
                              <i class="bi bi-arrow-right-short bsb-rotate-45"></i>
                            </span>
                            <div>

                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div
        className=""
        data-aos="fade-up"
        data-aos-anchor-placement="top-center"
      >
        <h2 className="text-center fs-1 p-0 m-0 mb-0">Testimonials</h2>
        <TestimonialSection />

      </div>
    </div>
  );
};

export default Home;

// माझ्या आयुष्या मधील NSS शिबिरामध्ये मुलांबरोबरचा पहिला अनुभव होता. मी या शिबिरामध्ये काही तासच होतो. या सात दिवसांच्या शिबिरामध्ये प्रतिकूल परिस्थितीमध्ये मुले आणि मुली राहून समाजसेवा करतात. श्री अमोल इंगोले सरांच्या नेतृत्वाखाली जवळपास ५० मुला-मुलांनी एकत्रित येऊन  बरीच सामाजिक उपक्रम गावामध्ये केली. त्यामध्ये लोकांना आर्थिक, सामाजिक,  बालिका सबलीकरण याचे महत्त्व प्रत्येकाशी बोलून किंवा सगळ्यांना रात्री एकत्र बोलवून पथनाट्यद्वारे सांगितले. काही मुले-मुली दिवसभर गावामध्ये असे बरेच उपक्रम राबवतात आणि काही मुलांचा समूह त्या बाकीच्या मुलांसाठी जेवण तयार करणे हे असे आळीपाळीने कडून हा उपक्रम नेटाने राबवणे यामधूनच सामाजिक बांधिलकी आणि एकत्रित काम करण्याची प्रवृत्ती दिसून येते.
//  ललित पाटील

